(() => {
  const contextNode = document.getElementById('SharpBrowseContext');
  if (!contextNode) return;
  let context;
  try { context = JSON.parse(contextNode.textContent); } catch { return; }
  const storageKey = `sharp-browse-v1:${context.theme}`;
  const filterAttribute = /^data-(?:sharp|youth|nicholls|teamstore|vikings|patterson).*(?:filter|primary|secondary|detail|group|type)$/;
  const linkSelector = '[data-category-return], [data-browse-return]';
  const maxAge = 2 * 60 * 60 * 1000;
  const read = () => {
    try { const saved = JSON.parse(sessionStorage.getItem(storageKey)); return saved && saved.pages && typeof saved.pages === 'object' ? saved : { pages: {} }; }
    catch { return { pages: {} }; }
  };
  let memory = read();
  const write = () => {
    try { sessionStorage.setItem(storageKey, JSON.stringify(memory)); } catch {}
  };
  const eligible = (url) => url.origin === location.origin &&
    /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:$|collections(?:\/|$)|products\/|search(?:\/|$)|pages\/|blogs(?:\/|$))/.test(url.pathname);
  const keyFor = (value) => {
    const url = new URL(value, location.origin);
    ['preview_theme_id', '_fd', 'pb', '_pos', '_sid', '_ss', 'utm_source', 'utm_medium', 'utm_campaign'].forEach(name => url.searchParams.delete(name));
    if (url.pathname.includes('/products/')) url.searchParams.delete('variant');
    url.hash = '';
    url.searchParams.sort();
    return url.pathname + url.search;
  };
  const currentKey = keyFor(location.href);
  const fresh = (record) => {
    try { return record && typeof record.url === 'string' && Date.now() >= record.time && Date.now() - record.time < maxAge && eligible(new URL(record.url, location.origin)); }
    catch { return false; }
  };
  const referrer = (() => { try { return new URL(document.referrer); } catch { return null; } })();
  const navType = performance.getEntriesByType('navigation')[0]?.type;
  let previous;
  if (navType === 'navigate' && memory.departure?.to === currentKey && fresh(memory.departure.from) && Date.now() - memory.departure.time < 60000 && (!referrer || (eligible(referrer) && keyFor(referrer.href) === keyFor(memory.departure.from.url)))) {
    previous = memory.departure.from;
    delete memory.departure;
  } else if (navType === 'reload' || navType === 'back_forward') {
    previous = memory.pages[currentKey]?.previous;
  } else if (referrer && eligible(referrer) && keyFor(referrer.href) === currentKey) {
    previous = memory.pages[currentKey]?.previous;
  } else if (referrer && eligible(referrer) && keyFor(referrer.href) !== currentKey) {
    const saved = memory.pages[keyFor(referrer.href)];
    if (fresh(saved)) {
      const { previous: parent, ...source } = saved;
      previous = source;
    } else previous = { url: referrer.pathname + referrer.search + referrer.hash, time: Date.now() };
  }
  if (!fresh(previous) || keyFor(previous.url) === currentKey) previous = null;
  if (context.type === 'product') {
    for (let depth = 0; previous && /\/products\//.test(new URL(previous.url, location.origin).pathname) && depth < 5; depth++) {
      const parent = memory.pages[keyFor(previous.url)]?.previous;
      previous = fresh(parent) && keyFor(parent.url) !== currentKey ? parent : null;
    }
  }
  const filterButtons = () => Array.from(document.querySelectorAll('#MainContent button[aria-pressed="true"]'))
    .filter(button => !button.closest('[hidden]') && Array.from(button.attributes).some(attr => filterAttribute.test(attr.name)));
  const attributesFor = (button) => Object.fromEntries(Array.from(button.attributes)
    .filter(attr => attr.name.startsWith('data-')).map(attr => [attr.name, attr.value]));
  const textFor = (button) => {
    const clone = button.cloneNode(true);
    clone.querySelectorAll('small, [data-nicholls-category-count], [data-nicholls-audience-count], [data-teamstore-category-count], [data-teamstore-audience-count], .sharp-patterson-categories__count, .sharp-patterson-audience__count').forEach(node => node.remove());
    return clone.textContent.trim().replace(/\s+/g, ' ');
  };
  const snapshot = () => {
    const buttons = filterButtons();
    const specific = buttons.filter(button => Array.from(button.attributes).some(attr => filterAttribute.test(attr.name) && attr.value !== 'all'));
    const heading = document.querySelector('#MainContent h1')?.textContent.trim().replace(/^Collection:\s*/i, '');
    const title = context.type === 'search' ? context.search : context.type === 'index' ? context.home : heading || context.title;
    return {
      url: location.pathname + location.search + location.hash,
      title: specific.length ? textFor(specific[specific.length - 1]) : title,
      controls: buttons.map(button => ({ attributes: attributesFor(button) })),
      fields: Array.from(document.querySelectorAll('#MainContent input[type="search"], #MainContent [data-sharp-team-finder] select'))
        .filter(field => field.id).map(field => ({ id: field.id, value: field.value })),
      scroll: Math.round(window.scrollY), time: Date.now(), previous
    };
  };
  const remember = () => {
    const page = snapshot();
    memory.pages[keyFor(page.url)] = page;
    const keys = Object.keys(memory.pages).sort((a, b) => memory.pages[b].time - memory.pages[a].time);
    keys.slice(20).forEach(key => delete memory.pages[key]);
    write();
  };
  const targetUrl = (source) => {
    const url = new URL(source.url, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  const updateLinks = () => {
    document.querySelectorAll(linkSelector).forEach(link => {
      if (!previous) return;
      const isNichollsReturn = /\/collections\/nicholls-state-university(?:-adult-copy)?$/.test(targetUrl(previous).pathname.replace(/\/$/, ''));
      const isPattersonReturn = /\/collections\/patterson-lumberjack-baseball$/.test(targetUrl(previous).pathname.replace(/\/$/, ''));
      if (link.dataset.teamStoreReturn === 'nicholls' && !isNichollsReturn) return;
      if (link.dataset.teamStoreReturn === 'patterson' && !isPattersonReturn) return;
      link.href = targetUrl(previous).href;
      const label = isPattersonReturn ? context.pattersonBack : isNichollsReturn ? context.nichollsBack : previous.title ? context.back.replace('__PAGE__', previous.title) : context.previous;
      const text = link.querySelector('[data-return-label]');
      if (text && text.textContent !== label) text.textContent = label;
    });
  };
  const restore = async () => {
    const saved = memory.pages[currentKey];
    const pending = memory.restore;
    const requested = pending?.key === currentKey && Date.now() - pending.time < 60000;
    if (!fresh(saved) || (!requested && navType !== 'back_forward')) return;
    delete memory.restore;
    write();
    for (const control of saved.controls || []) {
      const button = Array.from(document.querySelectorAll('#MainContent button')).find(node =>
        Object.entries(control.attributes).every(([name, value]) => node.getAttribute(name) === value));
      if (button && button.getAttribute('aria-pressed') !== 'true') {
        await new Promise(resolve => {
          let timer;
          const finish = () => { observer.disconnect(); clearTimeout(timer); resolve(); };
          const observer = new MutationObserver(() => { if (button.getAttribute('aria-pressed') === 'true') finish(); });
          observer.observe(button, { attributes: true, attributeFilter: ['aria-pressed'] });
          timer = setTimeout(finish, 3000);
          button.click();
          if (button.getAttribute('aria-pressed') === 'true') finish();
        });
      }
    }
    for (const field of saved.fields || []) {
      const node = document.getElementById(field.id);
      if (!node) continue;
      node.value = field.value;
      node.dispatchEvent(new Event('input', { bubbles: true }));
      node.dispatchEvent(new Event('change', { bubbles: true }));
    }
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    window.scrollTo({ top: saved.scroll || 0, behavior: 'instant' });
    await new Promise(resolve => requestAnimationFrame(resolve));
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.origin);
    if (!eligible(url) || keyFor(url.href) === currentKey) return;
    const page = snapshot();
    const { previous: parent, ...source } = page;
    memory.pages[keyFor(page.url)] = page;
    memory.departure = { from: source, to: keyFor(url.href), time: Date.now() };
    if (/\/(?:products\/|products_preview)/.test(url.pathname)) memory.productEntry = {key:keyFor(url.href),time:Date.now()};
    if (link.matches(linkSelector) && previous) {
      memory.restore = { key: keyFor(previous.url), time: Date.now() };
    }
    if (link.matches(linkSelector) && url.pathname.includes('nicholls')) {
      try { sessionStorage.setItem('sharp-team-return', JSON.stringify({ path: url.pathname, time: Date.now() })); } catch {}
    }
    write();
  }, true);
  const restrictNichollsMitt = () => {
    if (context.type !== 'product' || !location.pathname.includes('/products/tucci-sliding-mitt-with-storage-bag') || !previous || !/\/collections\/nicholls-state-university(?:-adult-copy)?$/.test(new URL(previous.url, location.origin).pathname.replace(/\/$/, ''))) return;
    const picker = document.querySelector('variant-selects[data-product-handle="tucci-sliding-mitt-with-storage-bag"]');
    if (!picker) return;
    const radios = [...picker.querySelectorAll('input[type="radio"][data-option-name="Color"]')];
    radios.forEach(input => {
      const allowed = /^(black|scarlet|red)$/i.test(input.value);
      const label = picker.querySelector('label[for="' + input.id + '"]');
      input.hidden = !allowed;
      if (label && !allowed) label.style.setProperty('display', 'none', 'important');
    });
    const selected = radios.find(input => input.checked);
    if (selected && !/^(black|scarlet|red)$/i.test(selected.value)) radios.find(input => /^black$/i.test(input.value))?.click();
    document.querySelectorAll('media-gallery img, product-modal img').forEach(img => {
      if (!/TUCCI.*(?:TRB|navy|royal|blue)/i.test(img.alt + ' ' + img.getAttribute('src'))) return;
      const item = img.closest('.product__media-item, .thumbnail-list__item, [data-media-id]');
      if (item && item.style.display !== 'none') item.style.setProperty('display', 'none', 'important');
    });
  };
  const ready = () => {
    restrictNichollsMitt();
    updateLinks();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches(linkSelector) || node.querySelector(linkSelector))))) updateLinks();
    }).observe(main, { childList: true, subtree: true });
    const productInfo = document.querySelector('product-info');
    if (productInfo) new MutationObserver(restrictNichollsMitt).observe(productInfo, {childList:true,subtree:true});
    restore().then(() => {
      const entry = memory.productEntry;
      if (context.type === 'product' && navType === 'navigate' && !location.hash && entry?.key === currentKey && Date.now() - entry.time < 60000) {
        delete memory.productEntry;
        write();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          window.scrollTo({ top: 0, behavior: 'instant' });
          remember();
        }));
      } else remember();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      memory = read();
      if (memory.departure?.to === currentKey && fresh(memory.departure.from)) {
        previous = memory.departure.from;
        delete memory.departure;
      }
    }
    updateLinks();
    if (event.persisted && memory.restore?.key === currentKey) {
      delete memory.restore;
      write();
    }
  });
})();



